import { render, staticRenderFns } from "./EMelderComponentMeldungenCommunicationLeftUser.vue?vue&type=template&id=6628114e&scoped=true"
import script from "./EMelderComponentMeldungenCommunicationLeftUser.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenCommunicationLeftUser.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentMeldungenCommunicationLeftUser.vue?vue&type=style&index=0&id=6628114e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6628114e",
  null
  
)

export default component.exports